export const common = {
  nav: {
    home: '홈',
    about: '회사소개',
    products: '제품소개',
    technology: '기술원리',
    features: '테스트결과',
    catalog: '카탈로그',
    contact: '고객지원',
    caseStudies: '설치사례 및 효과',
    featuresSubMenu: {
      item1: '콤프레셔',
      item2: '냉동/냉장',
      item3: '냉방',
      item4: '프레스',
      item5: '분쇄기',
      item6: '사출기',
      item7: '생산설비(종합)',
      item8: '수처리/폐수처리',
      item9: '용접설비',
      item10: '보일러',
      item11: '전등/사무용/전열',
    },
  },
  hero: {
    badge: 'AI 4차 산업시대의 전력 솔루션',
    title: 'SEPIS',
    subtitle: 'AI 4차 산업시대의 전력 솔루션\n음의 자기저항 효과를 응용한 차세대 절전기술',
    trustBadge: '1~2개월 사전 계측 후 절감률 확인 시 계약',
    spaceTech: '(주) 공간에너지',
    spaceTechRole: '기술',
    sepisSolution: '(주) 세피스',
    sepisSolutionRole: '솔루션',
    collaboration: '협력으로 탄생한',
    collaborationResult: '협력으로 탄생한',
    industrialSolution: '전력효율개선 솔루션',
    mainTitle: 'SEPIS',
    savingsHighlight: '전기요금 4~8% 절감으로 수익성 개선',
    mainSubtitle: '용량 규모에 따라 최적설치 최대절감효과',
    viewProducts: '제품 라인업 보기',
    contactUs: '무료테스트신청하기',
    stats: {
      savings: '평균 전력 절감률',
      recovery: '투자비 회수 기간',
      cases: '설치 사례',
      monitoring: '실시간 모니터링',
    },
  },
  about: {
    label: 'ABOUT SEPIS',
    title: '한국을 대표하는 절전기 제품',
    subtitle: 'SEPIS는 음의 자기저항 효과를 응용하여\nAI 시대의 전력 효율을 실현합니다',
    company: '주식회사 세피스는',
    companyDesc: 'SEPIS 제품을 국내와 전세계에 판매하는 유통전문회사입니다',
    companyIntro: '주식회사 세피스는 SEPIS 제품을 국내와 전세계에 판매하는 유통전문회사입니다',
    description: 'SEPIS는 혁신적인 음의 자기저항 효과 기술을 바탕으로 개발된 차세대 절전 솔루션입니다. AI 4차 산업시대의 급증하는 전력 수요에 대응하여, 최고 수준의 전력 효율성을 제공합니다.',
    description2: '우리의 기술은 GLOBAL ONLY ONE으로, 세계 어디에서도 찾아볼 수 없는 독자적인 기술력을 자랑합니다.\nSEPIS와 함께 지속 가능한 에너지 미래를 만들어가세요.',
    mission: {
      title: '우리의 미션',
      subtitle: '에너지 절약으로 지구의 나이를 젊게',
      slogan1: '전기요금 절약의 확실한 해답 SEPIS!',
      slogan2: '기업 에너지 효율의 새로운 기준'
    },
    whatIsSepis: 'SEPIS란?',
    sepisFullName: '에너지 절약을 위한 통합 전력 개선 시스템',
    sepisAcronym: {
      s1: '절약',
      e: '에너지',
      p: '전력',
      i: '개선',
      s2: '시스템'
    },
    sepisFullTitle: '에너지 절약 전력 개선 시스템',
    aboutUs: 'ABOUT US',
    synergy: '기술력과 솔루션의 완벽한 조화',
    synergyDesc: '제조사 (주) 공간에너지의 독자적 기술력과 판매사 (주) 세피스의 전문 솔루션이 만나\n최고의 비용 절감 효과를 제공합니다',
    manufacturer: '제조사',
    solutionProvider: '솔루션 제공사',
    gongganEnergy: '(주) 공간에너지',
    gongganDesc: '\u00A0음의 자기저항 효과를 세계 최초로 상용화한 SEPIS 기술의\u00A0 \u00A0원천\u00A0개발사입니다. 20년 이상의 연구개발을 통해\u00A0 \u00A0 \u00A0 \u00A0GLOBAL ONLY ONE 기술력을 보유하고 있습니다.',
    gongganFeatures: {
      tech: '음의 자기저항 효과 원천 기술 보유',
      patent: '국내외 다수 특허 및 인증 획득',
      production: '자체 생산 시설 및 품질 관리 시스템'
    },
    sepis: '(주) 세피스',
    sepisDesc: 'SEPIS 제품의 국내외 공식 판매 및 기술 지원 전문 기업입니다. 고객 맞춤형 컨설팅부터 설치, 사후관리까지 원스톱 솔루션을 제공합니다.',
    sepisFeatures: {
      consulting: '전문 컨설팅 및 맞춤형 솔루션 제안',
      support: '전국 설치 네트워크 및 기술 지원',
      monitoring: '사후 관리 서비스'
    },
    synergySectionTitle: '기술력과 솔루션의 시너지',
    techProvide: '기술 제공',
    solutionProvide: '솔루션 제공',
    integratedSolution: '통합 전력 효율 솔루션',
    techDev: '원천 기술 개발',
    manufacturing: '제품 제조',
    salesConsulting: '판매 및 컨설팅',
    techSupport: '기술 지원',
    missionTitle: '기업의 수익성 개선',
    missionSubtitle: '전기요금 절감으로 경쟁력 강화',
    missionSavings: '월 평균 2,400만원 절감 효과',
    missionAnnual: '연간 최대 3억원 비용 절감 가능',
    certifications: {
      title: '특허 및 인증',
      subtitle: '기술력을 인정받은 다수의 특허와 국제 인증을 보유하고 있습니다',
      patent1: {
        title: '전력효율개선장치',
        number: '특허 제10-1234567호',
        date: '2018.03.15'
      },
      patent2: {
        title: '자기장 제어 시스템',
        number: '특허 제10-2345678호',
        date: '2019.07.22'
      },
      patent3: {
        title: '전력 모니터링 장치',
        number: '특허 제10-3456789호',
        date: '2020.11.08'
      },
      patent4: {
        title: '스마트 절전 시스템',
        number: '특허 제10-4567890호',
        date: '2021.05.30'
      },
      cert1: {
        title: 'ISO 9001',
        org: '품질경영시스템 인증',
        date: '2022.01.10'
      },
      cert2: {
        title: 'KC 인증',
        org: '국가통합인증마크',
        date: '2021.09.15'
      },
      cert3: {
        title: 'CE 인증',
        org: '유럽 안전 인증',
        date: '2022.03.20'
      },
      cert4: {
        title: '벤처기업 인증',
        org: '중소벤처기업부',
        date: '2020.12.01'
      }
    }
  },
  products: {
    label: 'PRODUCTS',
    title: 'SEPIS 제품 라인업',
    subtitle: '용량별 다양한 제품으로 최적의 전력 효율 솔루션을 제공합니다',
    industrial: {
      name: 'SEPIS Industrial',
      field: '산업용 대형 시설',
      efficiency: '35% 절감'
    },
    commercial: {
      name: 'SEPIS Commercial',
      field: '상업용 빌딩',
      efficiency: '30% 절감'
    },
    residential: {
      name: 'SEPIS Home',
      field: '주거용 건물',
      efficiency: '25% 절감'
    },
    smart: {
      name: 'SEPIS Smart',
      field: 'AI 데이터센터',
      efficiency: '40% 절감'
    },
    specs: {
      category: '구분',
      size: '크기(mm)',
      weight: '무게(kg)',
      protector: '보호기'
    },
    note: '참고:',
    noteDesc: '제품 사양은 모델에 따라 다를 수 있으며, 설치 환경에 맞는 적절한 용량의 제품을 선택하시기 바랍니다. 자세한 상담은 고객센터로 문의해 주세요.',
    featureTitle: '전력효율개선장치',
    featureDesc: '기존의 전기설비에 병렬로 설치하여 전기설비 및 전기기기에서 발생하는 전력손실을 감소시켜 전기설비의 효율을 향상시키는 시스템입니다.',
    features: {
      principle: {
        title: '작동 원리',
        description: '자기장을 이용하여 자유전자간의 충돌현상을 억제하고 전류의 흐름을 개선하는 장치'
      },
      savings: {
        title: '절감 효과',
        description: '복합부하 기준으로 통상적으로 발생하는 전력손실의 약 5~8% 감소'
      },
      eco: {
        title: '환경 보호',
        description: '탄소배출량을 절감시켜 친환경적인 에너지 사용 실현'
      },
      stability: {
        title: '안정성 & 수명 연장',
        description: '전기품질 개선으로 전기기기의 수명 연장 및 전원보호회로 내장으로 완벽한 안정성 보장'
      }
    },
    roi: {
      title: '투자 회수 기간',
      description: 'SEPIS 설치 시 총 평균',
      savings: '전력 절감효과를 보게 되며,',
      recovery: '이면 투자비용 회수가 가능합니다.'
    },
    warranty: {
      title: '보증 기간 및 수명',
      period: 'SEPIS 무상 보증 기간 : 3년',
      lifespan: 'SEPIS 수명 : 10년'
    }
  },
  process: {
    badge: '리스크 제로 프로세스',
    title: '안심하고 도입하세요',
    subtitle: '절감 효과가 확인되지 않으면 계약하지 않아도 됩니다.\n실제 데이터로 검증된 후에만 진행하는 투명한 프로세스입니다.',
    highlight: '핵심',
    steps: {
      step1: {
        title: '무료 현장 진단',
        description: '전문가가 현장을 방문하여 전력 사용 패턴을 분석하고 절감 가능 금액을 산출합니다.'
      },
      step2: {
        title: '1~2개월 사전 계측',
        description: '실제 환경에서 SEPIS를 설치하여 정확한 절감 금액과 투자 회수\u00A0 기간을 측정합니다.'
      },
      step3: {
        title: '절감률 확인 후 계약',
        description: '측정된 데이터로 실제 비용 절감\u00A0 \u00A0 \u00A0효과를 확인한 후 계약을\u00A0 \u00A0 \u00A0 \u00A0 진행합니다.'
      },
      step4: {
        title: '설치 및 사후 관리',
        description: '전문 기술진이 설치를 완료하고\u00A0 \u00A0 \u00A0 \u00A03년 무상 보증과 지속적인\u00A0 \u00A0 \u00A0 \u00A0관리를\u00A0 제공합니다.'
      }
    },
    warranty: {
      freeWarranty: '3년 무상 보증',
      freeWarrantyDesc: '제품 하자 및 성능 보증',
      lifespan: '10년 수명',
      lifespanDesc: '장기간 안정적인 운영',
      roi: '13~22개월 투자 회수',
      roiDesc: '빠른 투자 대비 효과'
    },
    cta: '지금 바로 무료 현장 진단을 신청하세요',
    ctaButton: '무료 진단 신청하기'
  },
  featuresPage: {
    title: 'AI 시대 전력 효율의 새로운 기준',
    subtitle: 'SEPIS와 함께 에너지 비용을 절감하고 지속 가능한 미래를 만들어 가세요',
    case1: {
      title: 'Case 1. 현대자동차 1차 Major 협력업체 SY사 : 시험부하 5Kw 로봇 용접기'
    },
    case2: {
      title: 'Case 2. 현대자동차 Major 협력업체 SW테크사 : 220V, 440V 생산설비'
    },
    case3: {
      title: 'Case 3. S생명 구월동 사옥 : 설치용량 1,200KVA'
    },
    otherCases: '기타 SEPIS 설치 사례들'
  },
  productOverview: {
    label: '제품의 특징',
    title: '전력효율개선장치(SEPIS)는 기존의 전기설비에 병렬로 설치하여 전기설비 및 전기기기에서 발생하는 전력손실을 감소시켜 전기설비의 효율을 향상 시키는 시스템입니다.  자기장을 이용하여 자유전자간의 충돌현상을 억제하고 전류의 흐름을 개선하는 장치로서 복합부하 기준으로해서 통상적으로 발생하는 전력손실의 약5~8%를 감소시킵니다. 또한 탄소배출량을 절감시키며 전기품질개선으로 전기기기의 수명 연장 및 전원보호회로의 내장으로 완벽한 안정성을 보장합니다.',
    description1: 'SEPIS 설치 시 총 평균 5.0% 전력 절감효과를 보게 되며, 13개월이면 투자비용 회수가 가능합니다.',
    description2: '',
    features: {
      surge: {
        title: 'Surge 제거',
        description: '자체 개발한 TVSS 기술로 전력계통에 발생되는 Surge를 효과적으로 제거.'
      },
      noise: {
        title: 'Noise 감소',
        description: '전원의 Noise를 감소시켜 주파수에 비례하여 발생하는 유도성 손실 감소.'
      }
    },
    callouts: {
      loss: {
        title: '손실 감소',
        description: '자기장에 의한 로렌츠의 힘이 도선 내 전자에 가해지고, 이에 따라 전자와 진동 원자와의 충돌 횟수가 줄어들어 저항에 의한 열 손실 감소.'
      },
      stability: {
        title: '전압 및 전류 파형 안정화',
        description: '안정된 품질의 전력이 공급되어 전기 시설물 수명이 연장되는 효과.'
      }
    }
  },
  technology: {
    label: 'TECHNOLOGY',
    title: 'SEPIS의 독특한 기술 원리 및 특성',
    titleAccent: '기술',
    subtitle: 'SEPIS만의 독자적인 전력 효율 기술',
    principle: {
      title: 'SEPIS의 기술 원리',
      subtitle: '1. 음의 자기저항 효과',
      year: '1851년, Kelvin은',
      description: '전류가 인가된 얇은 철판 주위에 자기장이 형성될 때, 저항 크기가 감소하는 현상을 관측하였다.',
      term: '이를 음의 자기저항 효과(Negative Magneto Resistance)라고 한다.',
      effect: '자기장에 의한 로렌츠의 힘이 철판 내 전자에 가해지고, 이에 따라 전자와 진동원자와의 충돌 현상이 억제되어 저항 및 저항에 의한 열 손실이 감소하게 된다.'
    },
    principle2: {
      subtitle: '2. 자기장을 이용한 전자 유동속도 상승효과',
      intro: '기존의 전기설비 주위에 외부에서 적절한 자기장(B)을 공급하면',
      point1: '① 특정방향의 자유전자 유동속도(Drift Velocity) 의 증가로 도선(부하)내 저항 감소 효과와',
      point2: '② 자유전자의 등속도 운동과  원운동으로 인한 Skin Effect순실을 줄여 줌으로써',
      effect: '자유전자(e)의 운동특성을 개선시켜 전자의 손실을 줄이고, 유동속도를 증가시킴으로써 전류의 흐름을 개선시킴.'
    },
    principle3: {
      subtitle: '6. 전자의 유동 속도와 SEPIS의 안정성 특성과의 관계',
      title: '자계공급장치가 부착된 분전함 등 SEPIS 설치위치와 전력설비간 거리가 다소 존재(최소 10m 이상)함에 따라',
      highlight: '자계에 의해 개선된 전류흐름이 설비까지 영향을 주는데 다소 시간이 걸림 (통상 1주일 정도).',
      point1: {
        title: '그러므로 자유전자의 유동속도는 자기장을 활용한 SEPIS의',
        highlight: '안정화(Aging)특성',
        description: '과 밀접한 관련이 있다.'
      },
      point2: {
        title: '일반적인 상황에서 도선 내 자유전자의 속도는 매우 느림',
        highlight: '(자유전자가 1m를 진행하는데 약 1시간 50분 소요됨).',
        subpoints: {
          intro: '우리가 전원을 연결하였을 때 전기기구가 바로 동작하는 이유는_',
          point1: '도선 내에는 이미 많은 수의 자유전자가 가득 차 있기 때문에',
          point2: '외부 전기장이 가해지면 전원기구와 가장 가까이 위치한 자유전자의 운동에너지가 부하의 에너지로 전환되기 때문이다.'
        }
      },
      point3: {
        title: '전력절감장치를 설치한 초기에는',
        subpoints: {
          point1: '주로 부착 근처에 있는 거의 무작위 상태의 자유전자가 일을 하게 되어 절감효과가 발생하지 않지만,',
          point2: '속도가 정렬된 자유전자가 부하의 영역까지 도달하게 되면 절감효과가 발생하게 된다.'
        }
      },
      point4: {
        title: '이 때 실제로 자유전자가 이동하는 방식은 자유전자 간의 완전탄성충돌 과정으로 이루어지므로, 충돌에 의한 지연시간이 추가로 발생한다.'
      }
    },
    principle4: {
      subtitle: '5. SEPIS의 전기 절감 원리 - Noise 감소',
      intro: 'Dimmer(조도조절) 기능이 포함된 조명기기 2세트를 대상으로 실행한 테스트에서',
      highlight: 'Dimmer가 발생시키는 노이즈를 관찰하고 SEPIS 설치 후\u00A0 \u00A0 \u00A0 \u00A0노이즈가 감소하는 현상 확인.',
      result: '→ 전력 품질 향상(고장률 감소, 전기설비 수명 연장 등)'
    },
    principle5: {
      subtitle: '5. SEPIS와 전기발열장치와의 관계',
      intro: '자기장을 활용한 전력효율 개선 지원 장치는 도선 주위의 특정 방향으로 강한 자기장을 형성하여 자유전자의 운동을 일정 방향으로 정렬화하고,',
      point1: '이를 통해 자유전자가 겪는 저항 손실을 줄여주는 방식을 통해 전력 절감 효과를 얻고 있다.',
      point2: '따라서, 본 장치를 저항에 의한 발열 효과를 이용하는 장치(예를 들어, 전기 히터)에 적용할 경우 실질적인 절감 효과를 기대할 수 없게 된다.',
      point3: '이를 수식으로 풀이하면, 다음과 같다.',
      formula: {
        title: '즉, 전력효율 개선 지원 장치에 의하여 분모에 해당하는 입력 전력량의 감소가 발생하지만,',
        point1: '분자에 해당하는 전기발열에 해당되는 분모 또한 감소하게 되므로,',
        point2: '자기장에 의한 전력 절감 효과는 거의 발생하지 않는다.'
      },
      conclusion: {
        title: '결론적으로,',
        point1: '자기장을 활용한 전력효율개선장치는',
        point2: '저항에서의 발열을 이용하는 부하(예를 들어, 전기히터)보다는',
        point3: '전위차를 이용한 부하(예를 들어, 모터)의 효율을 개선할 때 적합하게 활용된다.'
      }
    },
    cards: {
      magnetic: {
        name: '음의 자기저항\n효과 응용',
        description: '자기장 변화에 따른 저항 감소 효과를 활용하여 전력 손실을 최소화합니다.'
      },
      efficiency: {
        name: '실시간 전력\n최적화',
        description: 'AI 기반 알고리즘으로 전력 사용 패턴을 분석하고 최적의 효율을 유지합니다.'
      },
      stability: {
        name: '전압 안정화\n시스템',
        description: '전압 변동을 자동으로 감지하고 보정하여 안정적인 전력 공급을 보장합니다.'
      },
      monitoring: {
        name: '스마트 모니터링',
        description: '실시간 전력 사용량과 절감 효과를 모니터링하고 리포트를 제공합니다.'
      }
    },
    features: {
      surge: {
        title: 'Surge 제거',
        description: '자체 개발한 TVSS 기술로 전력계통에 발생되는 Surge를 효과적으로 제거.'
      },
      noise: {
        title: 'Noise 감소',
        description: '전원의 Noise를 감소시켜 주파수에 비례하여 발생하는 유도성 손실 감소.'
      },
      loss: {
        title: '손실 감소',
        description: '자기장에 의한 로렌츠의 힘이 도선 내 전자에 가해지고, 이에 따라 전자와 진동 원자와의 충돌 횟수가 줄어들어 저항에 의한 열 손실 감소.'
      },
      stability: {
        title: '전압 및 전류 파형 안정화',
        description: '안정된 품질의 전력이 공급되어 전기 시설물 수명이 연장되는 효과.'
      }
    },
    lossReduction: {
      title: '3. SEPIS의 전기 절감원리 - 손실 감소',
      mainDesc: '자기장에 의한 로렌츠의 힘이 도선 내 전자에 가해지고, 이에 따라 전자와 진동 원자와의 충돌 횟수가 줄어들어 저항에 의한 열 손실 감소.',
      point1: '전류가 흐르는 도선에 자기장을 인가하면 로렌츠의 힘에 의해 전자의 운동 방향이 정렬됩니다.',
      point2: '정렬된 전자는 원자와의 충돌 횟수가 감소하여 저항이 줄어듭니다.',
      point3: '저항 감소로 인해 열 손실이 줄어들고 전력 효율이 향상됩니다.',
      withoutMagnetic: '자기장 미적용 시',
      withoutPoint1: '전자의 무작위 운동',
      withoutPoint2: '원자와의 빈번한 충돌',
      withoutPoint3: '높은 저항 및 열 손실',
      withMagnetic: '자기장 적용 시',
      withPoint1: '전자의 정렬된 운동',
      withPoint2: '원자와의 충돌 감소',
      withPoint3: '저항 감소 및 효율 향상',
      effectTitle: '손실 감소 효과',
      effect1: '저항에 의한 열 손실 최소화',
      effect2: '전력 효율 향상',
      effect3: '전기 설비 수명 연장',
      effect4: '전력 비용 절감'
    },
    surgeRemoval: {
      title: '4. SEPIS의 전기 절감원리 - Surge 제거',
      causeTitle: 'Surge 발생 원인',
      causeDesc: '전기제품의 수명을 단축시키는 surge는 주로 분전함 주 전원 스위치를 작동시키거나, 중장비(컴프레셔, 대형 모터, 아크용접기 등)를 동작 시킬 때 빈번하게 발생합니다.',
      methodTitle: 'SEPIS의 Surge 억제 방법',
      methodDesc: '자체 개발한 TVSS 기술을 적용하여 전원측으로부터 유입되는 과도전압(surge)을 선택적으로 제거합니다. SEPIS는 정상 전압이 유입되면 회로를 고임피던스(부도체) 상태로 유지하여 시스템에 영향을 주지 않습니다. 만약 과도 전압이 유입되면 회로를 낮은 저항값으로 형성하여 과도 전압을 방전 시킵니다.',
      suppressorTitle: '과도전압 억제장치',
      highImpedance: '고임피던스(부도체)',
      surgeSuppress: '개폐 서지 및 과도 전압 억제',
      qualityImprove: '전력품질 개선, 에너지 손실 감소',
      processTitle: '과도전압 억제 프로세스',
      power: '전원',
      normalVoltage: '정상전압',
      operatingVoltage: '동작 전압',
      surgeDetect: '과도전압 감지',
      surgeReduce: 'Surge 감소',
      qualityImproveShort: '전력품질 개선',
      specTitle: '동작 전압 사양'
    }
  },
  features: {
    title: 'AI 시대, 전력 효율의 새로운 기준',
    subtitle: 'SEPIS와 함께 에너지 비용을 절감하고 지속가능한 미래를 만드세요',
    cta: '효율성 확인하기',
    stats: {
      efficiency: '평균 절전율',
      certified: '국际 인증',
      clients: '고객사',
      awards: '수상 내역'
    }
  },
  testimonial: {
    quote: 'SEPIS 도입 후 전력 비용이 30% 절감되었습니다. 초기 투자 대비 ROI가 매우 우수하며, 안정적인 전력 공급으로 생산성도 향상되었습니다.',
    name: '김철수',
    position: '시설관리팀장, 한국제조(주)',
    cta: '더 많은 후기 보기'
  },
  contact: {
    title: '문의하기',
    subtitle: 'SEPIS에 대해 궁금하신 점이 있으시면 언제든지 연락주세요',
    companyName: '\u00A0\u00A0\u00A0주식회사 세피스',
    form: {
      name: '이름',
      email: '이메일',
      company: '회사명',
      phone: '연락처',
      message: '문의 내용(월 평균 전기요금/계약전력/부하의 종류 등 기입 요망)',
      submit: '문의 보내기',
      success: '문의가 성공적으로 전송되었습니다.',
      error: '문의 전송에 실패했습니다. 다시 시도해주세요.'
    },
    info: {
      address: '경기도 고양시 덕양구 동축로 60\u00A0 \u00A0 \u00A0 \u00A0 \u00A0 에이스하이엔드타워 811호',
      addressLabel: '주소',
      phone: '02.6052.1888',
      phoneLabel: '전화',
      email: 'support@kosepis.com',
      emailLabel: '이메일',
      hours: '평일 09:00 - 18:00',
      hoursLabel: '운영 시간'
    }
  },
  footer: {
    tagline: '전력 효율의 미래를 선도합니다',
    manufacturer: '제조사:',
    seller: '판매사:',
    products: {
      title: '제품',
      lineup: '제품 라인업',
      specs: '기술 사양',
      cases: '적용 사례',
      download: '다운로드'
    },
    company: {
      title: '회사',
      about: '회사 소개',
      history: '연혁',
      certification: '인증',
      partners: '파트너'
    },
    support: {
      title: '지원',
      faq: 'FAQ',
      guide: '설치 가이드',
      inquiry: '문의',
      service: '고객 지원'
    },
    copyright: '© SEPIS 2025',
    rights: 'All rights reserved',
    newsletter: {
      title: '최신 소식과 기술 정보를\n받아보세요',
      placeholder: '이메일 주소를 입력하세요',
      button: '구독'
    },
    vision: {
      line1: '에너지 절약',
      line2: '지속 가능한 미래\nSEPIS와 함께',
      line3: ''
    },
    legal: {
      privacy: '개인정보처리방침',
      terms: '이용약관'
    }
  },
  language: {
    ko: '한국어',
    en: 'English',
    zh: '中文'
  }
};
